/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeamFormationStatus } from './TeamFormationStatus';
import {
    TeamFormationStatusFromJSON,
    TeamFormationStatusFromJSONTyped,
    TeamFormationStatusToJSON,
    TeamFormationStatusToJSONTyped,
} from './TeamFormationStatus';
import type { ITeamMemberResponse } from './ITeamMemberResponse';
import {
    ITeamMemberResponseFromJSON,
    ITeamMemberResponseFromJSONTyped,
    ITeamMemberResponseToJSON,
    ITeamMemberResponseToJSONTyped,
} from './ITeamMemberResponse';

/**
 * Team API response
 * @export
 * @interface ITeamResponse
 */
export interface ITeamResponse {
    /**
     * 
     * @type {string}
     * @memberof ITeamResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ITeamResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ITeamResponse
     */
    captainId: string;
    /**
     * 
     * @type {string}
     * @memberof ITeamResponse
     */
    inviteToken?: string;
    /**
     * 
     * @type {Array<ITeamMemberResponse>}
     * @memberof ITeamResponse
     */
    members: Array<ITeamMemberResponse>;
    /**
     * 
     * @type {number}
     * @memberof ITeamResponse
     */
    pendingInviteCount: number;
    /**
     * 
     * @type {TeamFormationStatus}
     * @memberof ITeamResponse
     */
    status: TeamFormationStatus;
    /**
     * 
     * @type {number}
     * @memberof ITeamResponse
     */
    minMembers: number;
    /**
     * 
     * @type {number}
     * @memberof ITeamResponse
     */
    maxMembers: number;
    /**
     * 
     * @type {boolean}
     * @memberof ITeamResponse
     */
    isReady: boolean;
    /**
     * 
     * @type {number}
     * @memberof ITeamResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ITeamResponse
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the ITeamResponse interface.
 */
export function instanceOfITeamResponse(value: object): value is ITeamResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('captainId' in value) || value['captainId'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    if (!('pendingInviteCount' in value) || value['pendingInviteCount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('minMembers' in value) || value['minMembers'] === undefined) return false;
    if (!('maxMembers' in value) || value['maxMembers'] === undefined) return false;
    if (!('isReady' in value) || value['isReady'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ITeamResponseFromJSON(json: any): ITeamResponse {
    return ITeamResponseFromJSONTyped(json, false);
}

export function ITeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'captainId': json['captainId'],
        'inviteToken': json['inviteToken'] == null ? undefined : json['inviteToken'],
        'members': ((json['members'] as Array<any>).map(ITeamMemberResponseFromJSON)),
        'pendingInviteCount': json['pendingInviteCount'],
        'status': TeamFormationStatusFromJSON(json['status']),
        'minMembers': json['minMembers'],
        'maxMembers': json['maxMembers'],
        'isReady': json['isReady'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function ITeamResponseToJSON(json: any): ITeamResponse {
    return ITeamResponseToJSONTyped(json, false);
}

export function ITeamResponseToJSONTyped(value?: ITeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'captainId': value['captainId'],
        'inviteToken': value['inviteToken'],
        'members': ((value['members'] as Array<any>).map(ITeamMemberResponseToJSON)),
        'pendingInviteCount': value['pendingInviteCount'],
        'status': TeamFormationStatusToJSON(value['status']),
        'minMembers': value['minMembers'],
        'maxMembers': value['maxMembers'],
        'isReady': value['isReady'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

